import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import IconModal from "shared/components/IconModal";
import _str from "shared/util/_str";
import Str from "shared/components/Str";
import BoostTokenIcon from "shared/components/svgs/boost_token.svg";
import BoostBoltIcon from "../../icons/BoostBolt.svg";
import {
	viewedFirstPartyPromoEvent,
} from "../../analytics";

import "./FinishedBoostModal.scss";

const FinishedBoostModal = ({ boostAgain, onClose, show, viewMultiplier }) => {
	useEffect(() => {
		if (show) {
			viewedFirstPartyPromoEvent();
		}
	}, [show]);

	const cachedViewMultiplier = useRef();
	useEffect(() => {
		if (viewMultiplier !== null) {
			cachedViewMultiplier.current = viewMultiplier;
		}
	}, [show, viewMultiplier]);

	return (
		<IconModal
			onClose={onClose}
			show={show}
			image={<BoostTokenIcon height={67} width={61} className="finished-boost-modal-icon" />}
			headerText={_str("Your Boost worked!")}
			bodyText={_str(`You just increased your profile views  ${cachedViewMultiplier.current}x.  Nice work.  👌`)}
			footerChildren={(
				<button
					className="finished-boost-modal-button"
					onClick={boostAgain}
				>
					<BoostBoltIcon className="finished-boost-modal-button-icon" /> <Str>Boost Again</Str>
				</button>
			)}
		/>
	);
};

FinishedBoostModal.propTypes = {
	boostAgain: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	show: PropTypes.bool,
	viewMultiplier: PropTypes.number,
};

FinishedBoostModal.defaultProps = {
	show: false,
	viewMultiplier: 1.1,
};

export default FinishedBoostModal;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/BoostButton/FinishedBoostModal/FinishedBoostModal.jsx